import axios from './../api' // 倒入 api
const getTotalMilege = () => {
  return axios({
    url: '/api/bigscreen/total/vehicle/mileage',
    method: 'GET',
  })
}
const getSevenRank = (params) => {
  return axios({
    url: '/api/bigscreen/vehicle/mileage/rank',
    method: 'GET',
    params,
  })
}
const getCarStatus = () => {
  return axios({
    url: '/api/bigscreen/vehicle/status',
    method: 'GET',
  })
}
const getSafeRate = (orgId) => {
  return axios({
    url: `/api/bigscreen/as/risk?orgId=${orgId}&timeType=1`,
    method: 'GET',
  })
}
const warnRank = () => {
  return axios({
    url: '/api/bigscreen/as/risk/top',
    method: 'GET',
  })
}
const monitorData = (orgId) => {
  return axios({
    url: `/api/bigscreen/time/monitor?orgId=${orgId}`,
    method: 'GET',
  })
}
const getPointsData = () => {
  return axios({
    url: `/api/bigscreen/carDistributed`,
    method: 'get',
  })
}

const getCarOrderInfo = (orgId) => {
  return axios({
    url: `/api/bigscreen/carorder/info?orgId=${orgId}`,
  })
}
const getCarService = (orgId) => {
  return axios({
    url: `/api/bigscreen/carservice?orgId=${orgId}`,
  })
}
const getBigScreenAlarm = (orgId) => {
  return axios({
    url: `/api/bigscreen/alarm?orgId=${orgId}`,
  })
}
const bigScreenCarMonitorList = (orgId) => {
  return axios({
    url: `/api/bigscreen/carmonitor?orgId=${orgId}`,
  })
}

const bigScreenCarDetail = (plateNumber) => {
  return axios({
    url: `/api/bigscreen/car/detail?plateNumber=${plateNumber}`,
  })
}
const bigScreenOrgChild = (orgId) => {
  return axios({
    url: `/api/org/child/${orgId}`,
  })
}

export default {
  getTotalMilege,
  getSevenRank,
  getCarStatus,
  getSafeRate,
  warnRank,
  monitorData,
  getPointsData,
  getCarOrderInfo,
  getCarService,
  getBigScreenAlarm,
  bigScreenCarMonitorList,
  bigScreenCarDetail,
  bigScreenOrgChild,
}
